<template>
  <el-dialog @close="cancel" :title="content.title" :visible.sync="content.show" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" class="table-container-dialog">
    <!-- 搜索框 -->
    <div class="table-filter-wrapper" style="margin-bottom: 16px;">
      <el-input v-model="filterKeyword" placeholder="Search..." clearable prefix-icon="el-icon-search" size="medium" style="width: 300px;" />
    </div>

    <!-- 表格 -->
    <div class="table-wrapper">
      <el-table :data="filteredData" border stripe :header-cell-style="headerCellStyle" :cell-style="cellCellStyle" :row-style="{ height: 'auto' }">
        <!-- 动态列渲染：从 content.columns 读取 -->
        <el-table-column v-for="(col, i) in content.columns" :key="i" :prop="col.prop" :label="col.label" :width="col.width" :align="col.align || 'left'" :show-overflow-tooltip="col.showOverflowTooltip === true">
          <template slot-scope="scope">
            <div :style="cellContentStyle(col)" v-html="highlightText(scope.row[col.prop], col)"></div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "TableTempOther",
  data() {
    return {
      filterKeyword: "",
      // 接收外部传入的所有配置
      content: {
        show: false,
        title: "",
        columns: [],
        data: [],
        TYPE: "" // 新增控制字段
      }
    };
  },
  computed: {
    filteredData() {
      if (!this.filterKeyword) return this.content.data || [];
      const kw = this.filterKeyword.toLowerCase();
      return this.content.data.filter((item) => {
        return this.getSearchableValues(item).some((v) =>
          String(v).toLowerCase().includes(kw)
        );
      });
    }
  },
  methods: {
    isInheritanceColumn(col) {
      const prop = col && col.prop;
      const label = col && col.label;

      return [prop, label].some((value) => {
        return String(value || "").trim().toLowerCase() === "inheritance";
      });
    },

    getSearchableValues(row) {
      const columns = this.content.columns || [];

      if (columns.length) {
        return columns
          .filter((col) => !this.isInheritanceColumn(col))
          .map((col) => row[col.prop]);
      }

      return Object.keys(row || {})
        .filter((key) => key.toLowerCase() !== "inheritance")
        .map((key) => row[key]);
    },

    // 表头样式（控制表头是否斜体）
    headerCellStyle() {
      const base = {
        background: "#f5f7fa",
        fontWeight: 600
      };
      // TYPE=1 → 表头全部斜体
      if (this.content.TYPE === 1) {
        return { ...base, fontStyle: "italic" };
      }
      // 默认 → 表头全部正常
      return base;
    },

    // 单元格内容样式（控制第一列是否斜体）
    cellCellStyle({ columnIndex }) {
      const column = (this.content.columns || [])[columnIndex] || {};
      if (Object.prototype.hasOwnProperty.call(column, "italic")) {
        return {
          padding: "10px 8px",
          whiteSpace: "normal",
          wordBreak: "break-word",
          fontStyle: column.italic ? "italic" : "normal"
        };
      }
      // 默认：第一列内容斜体
      if (this.content.TYPE !== 1 && columnIndex === 0) {
        return {
          padding: "10px 8px",
          whiteSpace: "normal",
          wordBreak: "break-word",
          fontStyle: "italic" // 内容斜体
        };
      }
      // 其他情况：正常样式
      return {
        padding: "10px 8px",
        whiteSpace: "normal",
        wordBreak: "break-word"
      };
    },

    cellContentStyle(col) {
      if (Object.prototype.hasOwnProperty.call(col || {}, "italic")) {
        return { fontStyle: col.italic ? "italic" : "normal" };
      }

      return {};
    },

    cancel() {
      this.content.show = false;
    },

    // 搜索高亮
    highlightText(text, col) {
      if (!this.filterKeyword || this.isInheritanceColumn(col)) return text;
      const reg = new RegExp(`(${this.filterKeyword})`, "gi");
      return String(text).replace(
        reg,
        "<span style='color:#1890ff;font-weight:bold'>$1</span>"
      );
    }
  }
};
</script>

<style scoped>
.table-filter-wrapper {
  display: flex;
  justify-content: flex-end;
}

.table-wrapper ::v-deep .el-table .cell {
  white-space: normal !important;
  word-break: break-word !important;
  overflow: visible !important;
  text-overflow: clip !important;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TableTemp.vue